/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	chatMessages    : [],
	chatUnreadCount : { single: [], group: [] },
	mediaView       : { state: false, type: null, file: null },
	chatMediaStatus : { mediaLinks: 0, tabValue: 0 },
	mediaData     		: [],
	chatList        : {
		singleList       : [],
		groupList        : [],
		broadCastList    : [],
		singleContact    : [],
		groupContact     : [],
		myNetworkContact : [],
		broadCastContact : [],
		myCompany        : null
	}
};

export const chatSlice = createSlice({
	name     : 'chat',
	initialState,
	reducers : {
		updatechatUnreadCount : (state, action) =>
		{
			state.chatUnreadCount = action.payload;
		},
		updateMediaView : (state, action) =>
		{
			if (state.mediaView.state)
			{
				state.mediaView = initialState.mediaView;
			}
			else
			{
				state.mediaView =
					{ state    : true,
						type     : action.payload.type,
						file     : action.payload.file,
						imgIndex : action.payload.imgIndex };
			}
		},
		updateChatMediaStatus : (state, action) =>
		{
			state.chatMediaStatus =
				{ mediaLinks: action.payload.mediaLinks, tabValue: action.payload.tabValue };
			state.mediaData = [];
		},
		updateMediaList : (state, action) =>
		{
			state.mediaData = action.payload;
		},
		setChatTabList : (state, action) =>
		{
			state.chatList = { ...state.chatList, ...action.payload };
		},
		resetChat()
		{
			return initialState;
		}
	}
});

export const {
	updatechatUnreadCount,
	updateMediaView,
	updateChatMediaStatus, updateMediaList, setChatTabList, resetChat } = chatSlice.actions;
export default chatSlice.reducer;